<div class="lb-bg br-15 p-4">
  <div class="container contact">
    <div class="row">
      <h3 class="mb-0 text-center">
        <span style="margin-right: 1rem;">Connect with us</span><a href="mailto:{{email3PR| rot13Decrypt}}"><i class="fa-solid fa-envelope"></i>{{email3PR| rot13Decrypt}}</a>
      </h3>
    </div>
  </div>
</div>
